import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Jayme',
    reviewText:
      'Zola was so easy to use, and offers a generous discount for items still on your registry. The customer support was A+',
    title: 'So easy and best discount',
  },
  {
    name: 'OHughes',
    reviewText:
      'I’d recommend Zola to ANYONE and everyone getting married. They have literally everything - plus the 20% post married discount is insane!',
    title: 'Zola has everything!',
  },
  {
    name: 'Mollie',
    reviewText:
      'Zola had everything we were looking for. The cash funds were specifically designed for our busy life and honeymoon needs. We loved being able to ad...',
    title: 'Highly recommend',
  },
];
